import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';

import { defaultSAL1020_R01DetailDto, defaultSAL1020_R01HeaderDto, SAL1020_R01DetailDto, SAL1020_R01HeaderDto } from './Dto_SAL1020_R01';

export interface SAL1020_R01Filter {
	compCd: string;
	dateRange: DateRange | undefined;
	customCd: string;
	customNm: string;
	empNo: string;
	empNm: string;
	refetchListLength?: number;
}	

export interface Store_SAL1020_R01 {
	SAL1020_R01Filter: SAL1020_R01Filter;
	SAL1020_R01PastFilter: SAL1020_R01Filter;
	setSAL1020_R01Filter: (filter: Partial<Store_SAL1020_R01['SAL1020_R01Filter']>) => void;
	setSAL1020_R01PastFilter: (filter: Store_SAL1020_R01['SAL1020_R01PastFilter']) => void;

	// ====== 수주 헤더 리스트 및 선택/편집 ======
	SAL1020_R01List: SAL1020_R01HeaderDto[];
	setSAL1020_R01List: (list: SAL1020_R01HeaderDto[]) => void;

	editSAL1020_R01: SAL1020_R01HeaderDto | null;
	setEditSAL1020_R01: (edit: SAL1020_R01HeaderDto | null) => void;

	selectedSAL1020_R01: SAL1020_R01HeaderDto | undefined;
	setSelectedSAL1020_R01: (data: SAL1020_R01HeaderDto | undefined) => void;
	initSelectedSAL1020_R01: () => void;

	// ====== 수주 상세(디테일) 데이터 ======
	SAL1020_R01DetailList: SAL1020_R01DetailDto[];
	setSAL1020_R01DetailList: (data: SAL1020_R01DetailDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	allCount: number;
	setAllCount: (allCount: number) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;

	// ====== 초기화 ======
	initData: () => void;
}

export const defaultSAL1020_R01Filter: SAL1020_R01Filter = {
	compCd: '',
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: new Date()
	},
	customCd: '',
	customNm: '',
	empNo: '',
	empNm: ''
};

export const useSAL1020_R01Store = create<Store_SAL1020_R01>((set) => ({
	SAL1020_R01Filter: defaultSAL1020_R01Filter,
	SAL1020_R01PastFilter: defaultSAL1020_R01Filter,
	setSAL1020_R01Filter: (update) => set((state) => ({
		SAL1020_R01Filter: {
			...state.SAL1020_R01Filter,
			...update
		}
	})),
	setSAL1020_R01PastFilter: (filter: Store_SAL1020_R01['SAL1020_R01PastFilter']) => set((state) => {
		return {
			...state,
			SAL1020_R01PastFilter: filter
		}
	}),

	// ====== 수주 헤더 리스트 및 선택/편집 ======
	SAL1020_R01List: [],
	setSAL1020_R01List: (list: SAL1020_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			SAL1020_R01List: list
		}
	}),

	editSAL1020_R01: defaultSAL1020_R01HeaderDto,
	setEditSAL1020_R01: (edit: SAL1020_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editSAL1020_R01: edit
		}
	}),

	selectedSAL1020_R01: undefined,
	setSelectedSAL1020_R01: (data: SAL1020_R01HeaderDto | undefined) => set((state) => {
		return {
			selectedSAL1020_R01: data,
			SAL1020_R01DetailList: [],
			detailScrollTop: null,
		};
	}),
	initSelectedSAL1020_R01: () => set({ selectedSAL1020_R01: undefined, SAL1020_R01DetailList: [] }),

	// ====== 수주 상세(디테일) 데이터 ======
	SAL1020_R01DetailList: [],
	setSAL1020_R01DetailList: (data: SAL1020_R01DetailDto[]) => set((state) => {
		const newList = data.map((item, index) => ({
			...item,
			valueIndex: item.valueIndex > 0 ? item.valueIndex : index + 1,
			orderIndex: item.orderIndex > -1 ? item.orderIndex : index + 1,
			orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
		}));
		
		return {
			...state,
			SAL1020_R01DetailList: newList
		};
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	allCount: 0,
	setAllCount: (allCount: number) => set({ allCount }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		SAL1020_R01Filter: defaultSAL1020_R01Filter,
		SAL1020_R01PastFilter: defaultSAL1020_R01Filter,
		SAL1020_R01List: [],
		selectedSAL1020_R01: undefined,
		SAL1020_R01DetailList: [],
		editSAL1020_R01: defaultSAL1020_R01HeaderDto,
		allCount: 0,
		columnState: null,
		detailColumnState: null,
		scrollTop: null,
		detailScrollTop: null,
	})),
}));

